import localStorageIds from '../constants/localStorageIds'
import ORGANISATION_TYPES from '../constants/OrganisationTypes'
import localStorageHelper from './localStorageHelper'

const isSelectedOrgCompetitionOrFederation = () => {
  const { localStorageValue: selectedOrg } = localStorageHelper(localStorageIds.SELECTED_ORG)

  if (!selectedOrg) return false

  return selectedOrg.type === ORGANISATION_TYPES.ORG_COMPETITION || selectedOrg.type === ORGANISATION_TYPES.ORG_FEDERATION
}

export default isSelectedOrgCompetitionOrFederation
